import getReturnMethod, { EPARCEL } from './GetReturnMethod';
import { Settings } from '../types/settings';

export const DETAILS = 'details';
export const METHOD = 'method';
export const SUMMARY = 'summary';

export interface Step {
  id: string;
  name: string;
  path: string;
}

export function initialiseSteps(settings: Settings, merchantRef: string) {
  const method = getReturnMethod(settings);
  const steps: Array<Step> = [
    {
      id: DETAILS,
      name: 'Return Details',
      path: `/${merchantRef}/order`,
    },
    {
      id: METHOD,
      name: 'Return Method',
      path: `/${merchantRef}/methods`,
    },
    {
      id: SUMMARY,
      name: 'Confirm & Book',
      path: `/${merchantRef}/summary`,
    },
  ];

  if (method === EPARCEL) {
    steps.splice(1, 1);
  }

  return steps;
}

export function getCurrentPosition(steps: Array<Step>, id: string) {
  return steps.findIndex(s => s.id === id);
}

export function getNextStep(steps: Array<Step>, id: string) {
  const current = getCurrentPosition(steps, id);
  if (current + 1 > steps.length - 1) {
    return '';
  }

  const next = steps[current + 1];
  return next.path;
}

export function getNextId(steps: Array<Step>, id: string) {
  const current = getCurrentPosition(steps, id);
  if (current + 1 > steps.length - 1) {
    return '';
  }

  const next = steps[current + 1];
  return next.id;
}

export function getLoginStep(merchantRef: string) {
  return {
    name: 'Return Details',
    path: `/${merchantRef}`,
  };
}
